import { Props } from './OrderSummary';
import { MarginProps } from '../../puck/reusable-props/margin';
import { showComponentProps } from '../../puck/reusable-props/showComponent';
import { isZeroOrEmpty } from '../../utils/isZeroOrEmpty';
import { viewPorts } from '../../utils/helper';
import { OrderAndUpSellSummary } from '../../interface/commonInterface';
import { IBorderValueProps } from '../../puck/reusable-props/Border';
import { getCurrencyWithSymbol } from '../../utils/formatPrice';
import { ICalculatedFee } from '../../interface/checkoutInterface';

type OrderSummaryDetailsProps = {
  showDivider?: boolean;
  Subtotal: Props;
  Shipping: Props;
  GrandTotal: Props;
  Discounts: Props;
  EstimatedAmount: Props;
  SalesTax: Props;
  CalculatedFees: Props;
  width: number;
  isEditPage: boolean;
  border: IBorderValueProps;
  value: OrderAndUpSellSummary | null;
  backgroundColor: string;
} & MarginProps &
  showComponentProps;

const OrderSummartDetais = ({
  Subtotal,
  Shipping,
  GrandTotal,
  Discounts,
  EstimatedAmount,
  SalesTax,
  CalculatedFees,
  width,
  isEditPage,
  value,
}: OrderSummaryDetailsProps) => {
  if (!value) return <div>No Data</div>;
  return (
    <div className={`space-y-6 lg:block `}>
      {((Subtotal?.showOnMobile && width && width <= viewPorts.mobile) ||
        (Subtotal?.showOnTablet &&
          width &&
          width > viewPorts.mobile &&
          width <= viewPorts.tablet) ||
        (Subtotal?.showOnDesktop && width && width > viewPorts.tablet)) && ( // Desktop: Width greater than tablet
        <div
          className={`flex items-center justify-between ${Subtotal?.fontSize} ${Subtotal?.fontWeight} ${Subtotal?.showDivider ? 'border-t border-gray-300 pt-2' : ''}`}
          style={{ color: Subtotal?.textColor }}>
          <dt>{Subtotal.placeholder}</dt>
          <dd>
            {value?.currencySymbol ?? '$'}
            {value?.subTotal || 0.0}
          </dd>
        </div>
      )}

      {((Discounts?.showOnMobile && width && width <= viewPorts.mobile) ||
        (Discounts?.showOnTablet &&
          width &&
          width > viewPorts.mobile &&
          width <= viewPorts.tablet) ||
        (Discounts?.showOnDesktop && width && width > viewPorts?.tablet)) &&
        (isEditPage ? (
          <div
            className={`flex items-center justify-between ${Discounts?.fontSize} ${Discounts?.fontWeight} ${Discounts?.showDivider ? 'border-t border-gray-300 pt-2' : ''}`}
            style={{ color: Discounts?.textColor }}>
            <dt>{Discounts.placeholder}</dt>
            <dd>
              {value?.discount && !isZeroOrEmpty(value?.discount)
                ? `-${value?.currencySymbol || '$'}${value?.discount || 0.0}`
                : '-'}
            </dd>
          </div>
        ) : (
          <>
            {value?.discount && !isZeroOrEmpty(value?.discount) && (
              <div
                className={`flex items-center justify-between ${Discounts?.fontSize} ${Discounts?.fontWeight} ${Discounts?.showDivider ? 'border-t border-gray-300 pt-2' : ''}`}
                style={{ color: Discounts?.textColor }}>
                <dt>{Discounts.placeholder}</dt>
                <dd>
                  -{value?.currencySymbol ?? '$'}
                  {value?.discount || 0.0}
                </dd>
              </div>
            )}
          </>
        ))}

      {((Shipping?.showOnMobile && width && width <= viewPorts.mobile) ||
        (Shipping?.showOnTablet &&
          width &&
          width > viewPorts.mobile &&
          width <= viewPorts.tablet) ||
        (Shipping?.showOnDesktop && width && width > viewPorts.tablet)) && ( // Desktop: Width greater than tablet
        <div
          className={`flex items-center justify-between ${Shipping?.fontSize} ${Shipping?.fontWeight} ${Shipping?.showDivider ? 'border-t border-gray-300 pt-2' : ''}`}
          style={{ color: Shipping?.textColor }}>
          <dt>{Shipping.placeholder}</dt>
          <div className="flex">
            <dd>
              {value?.shippingCrg && !isZeroOrEmpty(value?.shippingCrg) ? (
                <>
                  {value?.currencySymbol ?? '$'}
                  {(
                    parseFloat(value?.currency_rate) *
                    parseFloat(value?.shippingCrg)
                  ).toFixed(2)}
                </>
              ) : (
                'Free'
              )}
            </dd>
          </div>
        </div>
      )}

      {((EstimatedAmount?.showOnMobile && width && width <= viewPorts.mobile) ||
        (EstimatedAmount?.showOnTablet &&
          width &&
          width > viewPorts.mobile &&
          width <= viewPorts.tablet) ||
        (EstimatedAmount?.showOnDesktop &&
          width &&
          width > viewPorts.tablet)) &&
        (isEditPage ? (
          <div className={``}>
            <div
              style={{ color: EstimatedAmount?.textColor }}
              className={`flex items-center justify-between ${EstimatedAmount?.fontSize} ${EstimatedAmount?.fontWeight} ${EstimatedAmount?.showDivider ? 'border-t border-gray-300 pt-2' : ''}`}>
              <dt>{EstimatedAmount.placeholder}</dt>
              <div className="flex">
                <dd>
                  {value?.currencySymbol ?? '$'}
                  {parseFloat(value.tax).toFixed(2) || 0.0}
                </dd>
              </div>
            </div>
          </div>
        ) : (
          <>
            {!!Number(value.tax) && (
              <div
                style={{ color: EstimatedAmount?.textColor }}
                className={`flex items-center justify-between ${EstimatedAmount?.fontSize} ${EstimatedAmount?.fontWeight} ${EstimatedAmount?.showDivider ? 'border-t border-gray-300 pt-2' : ''}`}>
                <dt>{EstimatedAmount.placeholder}</dt>
                <div className="flex">
                  <dd>
                    {value?.currencySymbol ?? '$'}
                    {parseFloat(value.tax).toFixed(2) || 0.0}
                  </dd>
                </div>
              </div>
            )}
          </>
        ))}
      {((SalesTax?.showOnMobile && width && width <= viewPorts.mobile) ||
        (SalesTax?.showOnTablet &&
          width &&
          width > viewPorts.mobile &&
          width <= viewPorts.tablet) ||
        (SalesTax?.showOnDesktop && width && width > viewPorts.tablet)) &&
        (isEditPage ? (
          <div
            className={`flex items-center pb-4 justify-between ${SalesTax?.fontSize} ${SalesTax?.fontWeight}`}
            style={{
              color: SalesTax?.textColor,
            }}>
            <dt>{SalesTax.placeholder}</dt>
            {value?.SalesTaxAmount && Boolean(Number(value?.SalesTaxAmount)) ? (
              <dd>
                {getCurrencyWithSymbol(
                  value?.currencyCode || 'USD',
                  value?.SalesTaxAmount,
                )}
              </dd>
            ) : (
              <dd>-</dd>
            )}
          </div>
        ) : (
          <>
            {value?.SalesTaxAmount &&
              Boolean(Number(value?.SalesTaxAmount)) && (
                <div
                  className={`flex items-center justify-between ${SalesTax?.fontSize} ${SalesTax?.fontWeight}`}
                  style={{
                    color: SalesTax?.textColor,
                  }}>
                  <dt>{SalesTax.placeholder}</dt>
                  <dd>
                    {getCurrencyWithSymbol(
                      value?.currencyCode || 'USD',
                      value?.SalesTaxAmount,
                    )}
                  </dd>
                </div>
              )}
          </>
        ))}
      {((CalculatedFees?.showOnMobile && width && width <= viewPorts.mobile) ||
        (CalculatedFees?.showOnTablet &&
          width &&
          width > viewPorts.mobile &&
          width <= viewPorts.tablet) ||
        (CalculatedFees?.showOnDesktop && width && width > viewPorts.tablet)) &&
        (isEditPage ? (
          <div
            className={`flex items-center pb-4 justify-between ${CalculatedFees?.fontSize} ${CalculatedFees?.fontWeight}`}
            style={{
              color: CalculatedFees?.textColor,
            }}>
            <dt>Calculated Fee</dt>
            <dd>-</dd>
          </div>
        ) : (
          <>
            {value?.CalculatedFees &&
              value?.CalculatedFees.map(
                (fee: ICalculatedFee, index: number) => (
                  <div
                    key={index}
                    className={`flex items-center justify-between ${CalculatedFees?.fontSize} ${CalculatedFees?.fontWeight}`}
                    style={{
                      color: CalculatedFees?.textColor,
                    }}>
                    <dt>{fee.FeeName || 'Calculated Fee'}</dt>
                    <dd>
                      {getCurrencyWithSymbol(
                        value?.currencyCode || 'USD',
                        fee.ComputedAmount,
                      )}
                    </dd>
                  </div>
                ),
              )}
          </>
        ))}
      {((GrandTotal?.showOnMobile && width && width <= viewPorts.mobile) ||
        (GrandTotal?.showOnTablet &&
          width &&
          width > viewPorts.mobile &&
          width <= viewPorts.tablet) ||
        (GrandTotal?.showOnDesktop && width && width > viewPorts.tablet)) && (
        <div
          className={`flex items-center justify-between  pt-6 ${GrandTotal.fontSize} ${GrandTotal.fontWeight} ${GrandTotal?.showDivider ? 'border-t border-gray-300 pt-2' : ''}`}
          style={{ color: GrandTotal?.textColor }}>
          <dt className="">{GrandTotal.placeholder}</dt>
          <dd className="">
            <span className="text-sm">{value?.currencyCode} </span>
            {value?.currencySymbol ?? '$'}
            {value?.orderTotal || 0.0}
          </dd>
        </div>
      )}
    </div>
  );
};

export default OrderSummartDetais;
